import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {authActions} from "./action-types";
import {catchError, concatMap, map, mergeMap, switchMap, tap} from "rxjs/operators";
import {IdamService} from "../../services/idam.service";
import {Router} from "@angular/router";
import {createAction} from "@ngrx/store";
import {EMPTY, of} from "rxjs";
import {genericActions} from "../general/action-types";

@Injectable()
export class AuthEffects {

  checkToken$ = createEffect(()=>
    this._actions$.pipe(
      ofType(authActions.authenticatingCheck),
      switchMap(()=> this._idamService.checkToken()),
      catchError(err=>{
        console.error(err);
        if (err.url.indexOf('refreshToken') > -1){
         if (err.error.data.errors.some((es: any) => es.indexOf('Not updated') > -1)){
           return of(authActions.authenticatingEnd({token:this._idamService.tokenValue, refreshToken: this._idamService.refreshTokenValue, forceRedirect: false}))
         }
        }
        void this._router.navigate(["auth"]);
        throw err;
      }),
      switchMap((tokens)=> {
        console.log('tokens', tokens);
        if (tokens && tokens.token && tokens.refreshToken){
          return [authActions.authenticatingEnd({token:tokens.token, refreshToken: tokens.refreshToken, forceRedirect: false})];
        }else{
          //void this._router.navigate(["auth"]);
          return [authActions.authenticatingCheckFailed()];
        }
    }),
    ), {dispatch: true}
  );

    authenticatingEnd$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(authActions.authenticatingEnd),
        tap((action) => {
          this._idamService.setToken(action.token, action.refreshToken);

          if (action.forceRedirect) {
            void this._router.navigate(["home"]);
          }
        }),
        switchMap(() => [genericActions.loadingProfile()
          , genericActions.loadingClient()
        ]),
      ),
    { dispatch: true }
  );

    loggingOut$ = createEffect(
      ()=>this._actions$
        .pipe(
          ofType(authActions.loggingOut),
          mergeMap(()=>this._idamService.logout()),
          concatMap(()=>{
            void this._router.navigate(["auth"]);
            return of(authActions.logOut())
          }),
          catchError(()=>{
            void this._router.navigate(["auth"]);
            return of(authActions.logOutFailed());
          })
        ), {dispatch: true}
    )

    constructor(private _actions$: Actions,
                private _idamService: IdamService,
                private _router: Router) {

    }
}
